module.exports = __webpack_public_path__ + "static/media/lvjian-longyueyasongfu.4e8f1b19.jpg";